import React from 'react';
import { Box, useMediaQuery } from '@chakra-ui/react';
import { useSelector } from 'react-redux';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import { getPlannerMode } from 'redux/PlannerModeSlice';
import { HEADER_HEIGHT_V1 } from 'projectConstants';
import BuilderMode from 'pages/BuilderMode';
import BuilderModeView from 'pages/BuilderModeV1/BuilderModeView';

import PlanPageScenario from './PlanPageScenario';
import PlanPageUIRevamp from './PlanPageUIRevamp';
import { getPlanPageUiRevampEnabled } from './PlanPageUIRevamp/usePlanPageUiRevamp';

export interface Properties {
  flags: any;
}

const PlanPageDetailsOPZ = ({ flags }: Properties) => {
  const [isLaptop]: any = useMediaQuery('(max-width: 1024px)');

  const plannerMode = useSelector(getPlannerMode);

  const planPageUiRevamp = getPlanPageUiRevampEnabled(flags);

  const showBuilderMode = plannerMode && !isLaptop;
  // The revamped plan page brings its own theme/background and renders full-bleed
  const isRevampVisible = !showBuilderMode && planPageUiRevamp;
  const isBuilderModeV1 = flags.builderModeUiRevamp;
  return (
    <Box
      height={`calc(100vh - ${!flags?.uiRevamp ? HEADER_HEIGHT_V1 : '0px'})`}
      bg={
        isRevampVisible
          ? 'linear-gradient(180deg, #FCFAF8 14.67%, #F5F2FF 48.8%, #FFF0FC 100%)'
          : 'gradient.body'
      }
      padding={isRevampVisible ? 0 : isLaptop ? 4 : ''}
      overflow='hidden'
      display='flex'
      flexDirection='column'
    >
      {showBuilderMode ? (
        isBuilderModeV1 ? (
          <BuilderModeView />
        ) : (
          <BuilderMode />
        )
      ) : planPageUiRevamp ? (
        <PlanPageUIRevamp />
      ) : (
        <PlanPageScenario />
      )}
    </Box>
  );
};

export default withLDConsumer()(PlanPageDetailsOPZ);
